"use strict";
exports.__esModule = true;
var benchImageCache = /** @class */ (function () {
    function benchImageCache() {
        this.cache = [];
    }
    benchImageCache.prototype.buildHash = function (imageParameters) {
        var result = this.buildBenchHash(imageParameters) +
            imageParameters.panelMaterial.panelWidth +
            imageParameters.panelMaterial.color +
            imageParameters.panelDirection +
            imageParameters.stove.name +
            imageParameters.stoveLightEnabled +
            imageParameters.benchLightEnabled +
            imageParameters.roofLightEnabled;
        return result;
    };
    benchImageCache.prototype.getCachedImage = function (hash) {
        return this.cache[hash];
    };
    benchImageCache.prototype.addToCache = function (hash, image) {
        this.cache[hash] = image;
    };
    benchImageCache.prototype.buildBenchHash = function (imageParameters) {
        var result = "";
        if (imageParameters.benchModel) {
            result = imageParameters.benchMaterial.id + "" +
                imageParameters.mirror +
                imageParameters.benchModel.name +
                imageParameters.benchModel.productLine.name;
            if (imageParameters.benchModel.productLine.usesProfileLayer)
                result += imageParameters.profileMaterial.color;
        }
        else {
            result = "nb";
        }
        return result;
    };
    benchImageCache.prototype.getImageAsync = function (imageParameters, imageBuilder) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var hash = _this.buildHash(imageParameters);
            var cachedImage = _this.getCachedImage(hash);
            if (cachedImage) {
                resolve(cachedImage);
            }
            else {
                imageBuilder().then(function (i) {
                    _this.addToCache(hash, i);
                    resolve(i);
                });
            }
        });
    };
    return benchImageCache;
}());
exports["default"] = benchImageCache;
//export default benchImageCache;
